// .zmn dosyası — Dava Zamanaşımı sayfasının girdi durumunu JSON olarak taşır.
// Tarihler, TarihGirisi ile tutarlı olsun diye YEREL "yyyy-mm-dd" biçiminde saklanır
// (toISOString UTC kayması yaratırdı). Saf fonksiyonlar — React/DOM gerektirmez, test edilebilir.

export const ZMN_TIP = 'takrir-zamanasimi';
export const ZMN_SURUM = 1;

const pad = (n) => String(n).padStart(2, '0');

const tarihStr = (d) =>
  d instanceof Date && !isNaN(d) ? `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` : null;

const tarihParse = (s) => {
  if (!s) return null;
  const [y, m, g] = String(s).split('-').map(Number);
  if (!y || !m || !g) return null;
  return new Date(y, m - 1, g); // yerel tarih — motor ve TarihGirisi ile tutarlı
};

/** Sayfa durumu → dışa aktarılacak düz nesne (tarihler yerel yyyy-mm-dd). */
export function zmnSerialize(state) {
  return {
    tip: ZMN_TIP,
    surum: ZMN_SURUM,
    veri: {
      sucTarihi: tarihStr(state.sucTarihi),
      zamanAsimiSuresi: state.zamanAsimiSuresi,
      dogumTarihi: tarihStr(state.dogumTarihi),
      manuelYasGrubu: !!state.manuelYasGrubu,
      secilenYasGrubu: state.secilenYasGrubu,
      kesenSebepler: (state.kesenSebepler || []).map((k) => ({
        tip: k.tip || '',
        tarih: tarihStr(k.tarih),
        aciklama: k.aciklama || '',
      })),
      durduranSebepler: (state.durduranSebepler || []).map((d) => ({
        tip: d.tip || '',
        baslangic: tarihStr(d.baslangic),
        bitis: tarihStr(d.bitis),
        aciklama: d.aciklama || '',
      })),
    },
  };
}

/**
 * .zmn metni/nesnesi → sayfa durumu (Date nesneleriyle). Geçersizse hata fırlatır.
 */
export function zmnParse(input) {
  const obj = typeof input === 'string' ? JSON.parse(input) : input;
  if (!obj || obj.tip !== ZMN_TIP || !obj.veri) {
    throw new Error('Geçersiz .zmn dosyası');
  }
  const v = obj.veri;
  return {
    sucTarihi: tarihParse(v.sucTarihi) || new Date(),
    zamanAsimiSuresi: Number(v.zamanAsimiSuresi) || 8,
    dogumTarihi: tarihParse(v.dogumTarihi),
    manuelYasGrubu: !!v.manuelYasGrubu,
    secilenYasGrubu: v.secilenYasGrubu || 'yetiskin',
    kesenSebepler: Array.isArray(v.kesenSebepler)
      ? v.kesenSebepler.map((k) => ({ tip: k.tip || '', tarih: tarihParse(k.tarih), aciklama: k.aciklama || '' }))
      : [],
    durduranSebepler: Array.isArray(v.durduranSebepler)
      ? v.durduranSebepler.map((d) => ({
          tip: d.tip || '',
          baslangic: tarihParse(d.baslangic),
          bitis: tarihParse(d.bitis),
          aciklama: d.aciklama || '',
        }))
      : [],
  };
}

/** Çıktı dosyası adı: "zamanasimi_2020-08-26.zmn". */
export function zmnDosyaAdi(state) {
  const t = tarihStr(state && state.sucTarihi);
  return `zamanasimi_${t || 'kayit'}.zmn`;
}
